import { render } from "./ListSecondArticle.vue?vue&type=template&id=40c22e47"
import script from "./ListSecondArticle.vue?vue&type=script&lang=js"
export * from "./ListSecondArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__